import axios from 'axios';
import { useState } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import ForgotPasswordForm from 'components/desktop/User/PasswordRecovery/ForgotPasswordForm';
import LoadingSpinner from 'components/desktop/_general/Loading/LoadingSpinner';
import LogoAnimation from 'components/desktop/_general/LogoAnimation/LogoAnimation';
import 'containers/desktop/User/PasswordRecovery/PasswordRecovery.scss';
import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import {
	ForgotPasswordDto,
	defaultForgotPasswordDto,
} from 'types/User/PasswordRecovery/ForgotPasswordDto';

const ForgotPassword = () => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [email, setEmail] = useState<string>('');
	const [forgotPasswordDto, _setForgotPasswordDto] = useState<ForgotPasswordDto>(
		defaultForgotPasswordDto()
	);
	const navigate = useNavigate();

	const handleSendLink = async () => {
		setIsLoading(true);
		const url = `${SERVICEBASEURL.USER}/user/ForgotPassword`;

		forgotPasswordDto.passwordRecoveryPageUrl = window.origin + '/passwordReset';
		forgotPasswordDto.email = email;

		try {
			await axios.post(url, forgotPasswordDto);
			navigate('/linkSentConfirmation');
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};

	const renderContent = () => {
		return (
			<>
				<section>
					<div className="wave">
						<span></span>
						<span></span>
						<span></span>
					</div>
					<div>
						<Card className="forgot-password-inner-container">
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
								}}
							>
								<div style={{ transform: 'scale(0.8)', transformOrigin: 'center' }}>
									<LogoAnimation />
								</div>
								<span
									style={{
										color: '#6066C1',
										fontWeight: 'bold',
										fontSize: '1rem',
									}}
								>
									Artificial Intelligence Recipes
								</span>
							</div>

							<Card.Body className="forgot-password-inner-container-div">
								{!isLoading ? (
									<ForgotPasswordForm
										email={email}
										setEmail={setEmail}
										handleSendLink={handleSendLink}
									/>
								) : (
									<LoadingSpinner />
								)}
								<div className="d-grid gap-2 mt-3">
									<button
										type="button"
										className="btn btn-outline-secondary"
										onClick={() => navigate('/login')}
									>
										{t('user:BACK_TO_LOGIN')}
									</button>
								</div>
							</Card.Body>
						</Card>
					</div>
				</section>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default ForgotPassword;
